/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
// import Loader from 'material/loader/loader';
// import Button from 'material/ctas/button/button_container';
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
// styles
// import injectSheet from 'react-jss';
// import styles from 'material/ctas/editembed/editembed_styles';



/* ========== ~~~~~~~~~~ CTA : EDIT EMBED ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class EditEmbedCTA extends Component {
  constructor(props) {
    super(props);
    this.state = { processing: false };
  }
  componentDidUpdate(prevProps) {
    if(!this.props.currentPage && prevProps.currentPage) { this.setState({ processing: false }) }
  }
  render() {
    return(
        <Link type={`action`}
               text={`Edit Embed`}
               color={this.props.color ? this.props.color : `primary`}
               action={() => this.props.editEmbed(this.props.embedUUID)}
               name={`editembed`} 
               icon={<Icon name={`edit`} />}
               handleClick={() => this.setState({ processing: true })}
               operation={`load`}
               processing={this.state.processing}
        />
    );
  }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EditEmbedCTA;
// export default injectSheet(styles)(EditEmbedCTA);